import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getParametersFromLocalStorage } from "../../helpers/commonHelper";
import { getSelectedLanguage } from "../../store/Checkin/languageSlice";
import "../../assets/stylesheet/style1.css";
import { GetMembershipCodeMaster } from "../../network/apiService";
// const PriorityBadge = ({ reservationData }) => {

//   const [membershipName, setMembershipName] = useState("");

//   const { t } = useTranslation();
//   const selectedLanguage = useSelector(getSelectedLanguage);
//   const [isEliteMember, setIsEliteMember] = useState(false);
//   const [showPriorityBadge, setShowPriorityBadge] = useState(false);
// const toLower = (s) => (s ?? "").toString().trim().toLowerCase();

//   useEffect(() => {
//     const settings = getParametersFromLocalStorage("settings");

//     const badgeSetting = settings?.find(
//       (setting) =>
//         setting.parameterName === "showPriorityBadge" &&
//         setting.parameterValue?.toLowerCase() === "true"
//     );
//     console.log("Badge Setting:", badgeSetting);

//     setShowPriorityBadge(!!badgeSetting);

//     const acceptedMembershipLevels = settings?.find(
//       (setting) => setting.parameterName === "EliteMembershipLevels"
//     );
//     console.log("Accepted Membership Levels:", acceptedMembershipLevels);
//     const eliteLevels =
//       acceptedMembershipLevels?.parameterValue
//         ?.split(",")
//         .map((level) => level.trim().toLowerCase()) || [];
//     console.log("Elite Levels:", eliteLevels);
//     console.log("Full Reservation Data:", reservationData);
// let memberships = [];

// if(reservationData?.[0] && reservationData?.[0]?.membership) {
//   console.log("Reservation Data:", reservationData);
//   console.log("Membership Data:", reservationData?.[0]?.membership);
// const reservation = reservationData?.[0]; // First reservation from array
// memberships = reservation?.membership ?? [];
// }
// else{
//   console.log("Reservation Data:", reservationData);
// // Extract all non-null memberships from reservations

//   memberships = reservationData?.membership ?? [];
// }

// console.log("Memberships:", memberships);
// // Elite levels list must be defined before this block
// const eliteMember = memberships.find((m) =>
//   eliteLevels.includes(toLower(m?.membershipLevel))
// ) || null;

// console.log("Elite Member:", eliteMember);

// let isElite = false;
//   if (reservationData?.membership?.length) {
//       isElite = reservationData.membership.some((member) =>
//         eliteLevels.includes(member.membershipLevel?.toLowerCase())
//       );
//     } else {
//       // fallback to local storage
//       isElite = JSON.parse(localStorage.getItem("isEliteMember") || "false");
//     }

// if (memberships.length > 0) {
//   isElite = !!eliteMember;
//   console.log("Is Elite Member:", isElite);
// } else {
//   // fallback to local storage
//   isElite = JSON.parse(localStorage.getItem("isEliteMember") || "false");
// }

//     setIsEliteMember(isElite);

//       if (!isElite || !eliteMember?.membershipLevel) return;
//        const token = getParametersFromLocalStorage("token");
//       if (!token) {
//         console.error("No token found in localStorage");
//         return;
//       }
//         const fetchMembership = async () => {
//     try {
//       const response = await GetMembershipCodeMaster(
//         { membershipLevel: eliteMember.membershipLevel },
//         token
//       );

//       console.log("Resolved API Response:", response);

//       const data = response.data;
//       if (data && data.length > 0) {
//         setMembershipName(data[0].display);
//       }
//     } catch (error) {
//       console.error("Error fetching membership name:", error);
//     }
//   };

//   fetchMembership();

//     // Save to localStorage
//     localStorage.setItem("isEliteMember", JSON.stringify(isElite));
//     localStorage.setItem("showPriorityBadge", JSON.stringify(!!badgeSetting));
//   }, [reservationData]);

//   if (!showPriorityBadge || !isEliteMember) return null;

// return (
//   <div>
//  <div className="priority-badge">
//   <div className="elite-badge">
//      <span class="icon"></span>
//     {membershipName || "Elite"}
//   </div>
// </div>
//   </div>
// );

// };

const PriorityBadge = ({ reservationData = null }) => {
  const [membershipName, setMembershipName] = useState("");
  const [isEliteMember, setIsEliteMember] = useState(false);
  const [showPriorityBadge, setShowPriorityBadge] = useState(false);

  const toLower = (s) => (s ?? "").toString().trim().toLowerCase();

  useEffect(() => {
    const settings = getParametersFromLocalStorage("settings") || [];

    // Badge toggle setting
    const badgeSetting = settings.find(
      (setting) =>
        setting.parameterName === "showPriorityBadge" &&
        toLower(setting.parameterValue) === "true"
    );
    const showBadge = !!badgeSetting;

    // Elite membership levels
    const acceptedMembershipLevels = settings.find(
      (setting) => setting.parameterName === "EliteMembershipLevels"
    );
    const eliteLevels =
      acceptedMembershipLevels?.parameterValue
        ?.split(",")
        .map((lvl) => toLower(lvl)) || [];

    let isElite = false;

    const isEmptyReservation =
      !reservationData ||
      (Array.isArray(reservationData) && reservationData.length === 0);

    if (isEmptyReservation) {
      // fallback from local storage
      isElite = localStorage.getItem("isEliteMember") === "true";
      setIsEliteMember(isElite);
      setShowPriorityBadge(showBadge);

      const stored = localStorage.getItem("membershipName");
      if (stored) setMembershipName(stored);
      return;
    }

    let memberships = [];

    if (reservationData?.[0]?.membership) {
      memberships = reservationData[0].membership;
    } else if (reservationData?.membership) {
      memberships = reservationData.membership;
    }

    const eliteMember = memberships.find((m) =>
      eliteLevels.includes(toLower(m?.membershipLevel))
    );

    // let isElite = false;
    if (eliteMember) {
      isElite = true;
    } else {
      // fallback from localStorage
      isElite = JSON.parse(localStorage.getItem("isEliteMember") || "false");
    }

    setIsEliteMember(isElite);
    setShowPriorityBadge(showBadge);

    if (!isElite || !eliteMember?.membershipLevel) return;

    const token = getParametersFromLocalStorage("token");
    if (!token) return;

    const fetchMembership = async () => {
      try {
        const response = await GetMembershipCodeMaster(
          { membershipLevel: eliteMember.membershipLevel },
          token
        );

        const data = response.data;
        if (data && data.length > 0) {
          setMembershipName(data[0].display);
          localStorage.setItem("membershipName", data[0].display);
        }
      } catch (err) {
        console.error("Error fetching membership name:", err);
      }
    };

    fetchMembership();

    // Store values to persist across pages
    localStorage.setItem("isEliteMember", JSON.stringify(isElite));
    localStorage.setItem("showPriorityBadge", JSON.stringify(showBadge));
  }, [reservationData]);

  if (!showPriorityBadge || !isEliteMember) return null;

  return (
    <div className="priority-badge">
      <div className="elite-badge">
        <span className="icon"></span>
        {membershipName || "Elite"}
      </div>
    </div>
  );
};

export default PriorityBadge;
